module.exports = __webpack_public_path__ + "static/media/dgl-with-boy.ebc38484.jpg";